var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Field } from 'react-redux-form';
import { Icon } from "../../UI";
import { Translate } from "../../I18N";

export class ThesauriFormField extends Component {
  constructor(props) {
    super(props);
    // eslint-disable-next-line react/no-unused-class-component-methods
    this.focus = () => {
      this.groupInput.focus();
    };
  }

  renderValue(_value, index, groupIndex) {
    const { removeValue } = this.props;
    let model = `thesauri.data.values[${index}].label`;
    if (groupIndex !== undefined) {
      model = `thesauri.data.values[${groupIndex}].values[${index}].label`;
    }
    return /*#__PURE__*/(
      _jsx("div", {}, `item-${groupIndex || ''}${index}`, /*#__PURE__*/
      _jsx(Field, { model: model }, void 0, /*#__PURE__*/
      _jsx("input", { className: "form-control", type: "text", placeholder: "Item name" }), /*#__PURE__*/
      _jsx("button", {
        tabIndex: index + 500,
        type: "button",
        className: "btn btn-xs btn-danger",
        onClick: removeValue.bind(null, index, groupIndex) }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "trash-alt" }), " ", /*#__PURE__*/_jsx(Translate, {}, void 0, "Delete")))));




  }

  render() {
    const { value, index, groupIndex } = this.props;
    return this.renderValue(value, index, groupIndex);
  }
}

ThesauriFormField.defaultProps = {
  groupIndex: undefined
};











export default ThesauriFormField;